import React from 'react'
import { SnvPotentialModelResult } from './SnvPotentialModelResult'
import { ISnvPotentialModelTileData } from './@types/ISnvPotentialModel'

export const SnvPotentialModel: React.FC<{ data: ISnvPotentialModelTileData, tileId: string }> = ({ data }) => (
  <SnvPotentialModelResult data={data} />
)
